module.exports = __webpack_public_path__ + "static/dab-32ce6aee44ac063101f0f1723d78bb73.png";